<script lang="ts">
  import Badge from '../lib/ui/Badge.svelte';
  import Button from '../lib/ui/Button.svelte';
  import Card from '../lib/ui/Card.svelte';
  import { ReportSendOverview } from '../lib/report-send-overview';
  import type { ReportDefinitionSends } from '../lib/report-definition-sends.svelte';

  interface Props {
    loader: ReportDefinitionSends;
    emptyNote: string;
    onOpen: () => void;
  }

  let { loader, emptyNote, onOpen }: Props = $props();

  const page = $derived(loader.page);
  const last = $derived(page?.items[0] ?? null);
  const overview = $derived(last ? new ReportSendOverview(last) : null);
</script>

<Card title="Envios" count={page?.total}>
  {#if loader.failedBeforeAnyPage}
    <p class="empty">Não deu para carregar os envios.</p>
  {:else if page === null}
    <p class="empty">Carregando os envios…</p>
  {:else if overview}
    <div class="last">
      <span class="who">
        <span class="name">Último: {overview.when}</span>
        {#each overview.topFailureReasons as reason (reason.label)}
          <span class="error">{reason.count} · {reason.label}</span>
        {/each}
        {#if overview.otherFailures > 0}
          <span class="error">+{overview.otherFailures} por outros motivos</span>
        {/if}
      </span>
      <Badge tone={overview.summary.tone} dot>{overview.summary.label}</Badge>
    </div>
    <div><Button size="sm" onclick={onOpen}>Ver os {page.total} envios →</Button></div>
  {:else}
    <p class="empty">{emptyNote}</p>
  {/if}
</Card>

<style>
  .last {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: start;
    gap: var(--space-4);
    margin-bottom: var(--space-3);
  }
  .who {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    min-width: 0;
  }
  .name {
    color: var(--text-primary);
    font-weight: 500;
  }
  .error {
    color: var(--color-danger);
    font-size: 12px;
    overflow-wrap: anywhere;
  }
  .empty {
    margin: 0;
    padding: var(--space-4) 0;
    text-align: center;
    color: var(--text-tertiary);
    font-size: 12px;
  }
</style>
